import PropTypes from "prop-types";
import { Container, SubContainer, ToolbarButton, ToolbarButtonExport, ToolbarButtonExportContainer, ToolbarIconButton, SearchButton as SearchButtonStyled } from "./styles/Toolbar.styled";
import { Tooltip } from "@mui/material";
import { Search as SearchIcon, SearchOffOutlined as SearchOffOutlinedIcon, Link as LinkIcon, VisibilityOff as VisibilityOffIcon, Add as AddIcon } from "@mui/icons-material";
import { CSSTransition } from "react-transition-group";
import "./styles/table.css";
import { useRef } from "react";

const SearchButton = ({ getNewData }) => {
  return (
    <SearchButtonStyled onClick={getNewData} startIcon={<SearchIcon />}>
      Search
    </SearchButtonStyled>
  );
};

const ResetSearchButton = ({ resetSearch }) => {
  return (
    <Tooltip title="Reset filters">
      <ToolbarIconButton onClick={resetSearch} aria-label="Reset filters">
        <SearchOffOutlinedIcon fontSize="small" />
      </ToolbarIconButton>
    </Tooltip>
  );
};

const ExportLinkButton = ({ rowSelectionModel = [], redirectToPreviewsPage }) => {
  const nodeRef = useRef(null);
  return (
    <CSSTransition in={!!rowSelectionModel.length} timeout={300} classNames="slide" unmountOnExit nodeRef={nodeRef}>
      <ToolbarButtonExportContainer ref={nodeRef}>
        <ToolbarButtonExport startIcon={<LinkIcon />} onClick={() => redirectToPreviewsPage(false)}>
          Export links
        </ToolbarButtonExport>
        <ToolbarButtonExport startIcon={<VisibilityOffIcon />} onClick={() => redirectToPreviewsPage(true)}>
          Export anonymous links
        </ToolbarButtonExport>
      </ToolbarButtonExportContainer>
    </CSSTransition>
  );
};

const AddButton = ({ openPopinAdd, label }) => {
  return (
    <ToolbarButton startIcon={<AddIcon />} onClick={openPopinAdd} variant="contained" color="primary">
      Create new {label}
    </ToolbarButton>
  );
};

export default function Toolbar({ openPopinAdd, hasFilter, rowSelectionModel, redirectToPreviewsPage, hasActiveFilter, tableId, saveSearch, resetSearch, getNewData, label, handleSavedSearchesPopin }) {
  return (
    <Container>
      <SubContainer>
        <AddButton openPopinAdd={openPopinAdd} label={label} />
        {hasFilter && <ExportLinkButton rowSelectionModel={rowSelectionModel} redirectToPreviewsPage={redirectToPreviewsPage} />}
      </SubContainer>
      <SubContainer>
        {/* {hasFilter && hasActiveFilter && tableId === "projects" && <RegisterSearchButton saveSearch={saveSearch} />} */}
        {hasFilter && hasActiveFilter && <ResetSearchButton resetSearch={resetSearch} />}
        {hasFilter && <SearchButton getNewData={getNewData} />}
        {/* {hasFilter && label === "project" && <FavoriteSearchButton handleSavedSearchesPopin={handleSavedSearchesPopin} />} */}
      </SubContainer>
    </Container>
  );
}

Toolbar.propTypes = {
  openPopinAdd: PropTypes.func.isRequired,
  hasFilter: PropTypes.bool.isRequired,
  rowSelectionModel: PropTypes.array.isRequired,
  redirectToPreviewsPage: PropTypes.func.isRequired,
  hasActiveFilter: PropTypes.bool.isRequired,
  // tableId: PropTypes.string.isRequired,
  // saveSearch: PropTypes.func.isRequired,
  resetSearch: PropTypes.func.isRequired,
  getNewData: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  // handleSavedSearchesPopin: PropTypes.func.isRequired,
};
